import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Observable, BehaviorSubject, of, from } from "rxjs";
import { catchError, mapTo, tap} from 'rxjs/operators'
import { Token} from './token'
import { Constants } from './constants'
import { Location} from '@angular/common'
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DatabaseApiServiceService {

  private API_URL: string;
  private loggedInUser: string;
  private loggInCompany: string;
  private loggedInCompanyWebsite: string;



  constructor(private httpClient: HttpClient, private loc: Location, private router: Router) {
    // this.API_URL = 'https://190.213.218.14:5001/';
    this.API_URL = 'https://app.ssdl-tt.com:5001/';
    // this.API_URL = 'http://localhost:5001/';
   }

  public login(username: string, password: string): Observable<any>{
    console.log("Logging In");
    let url = this.API_URL + 'login';
    let headers = new HttpHeaders({'Content-Type': 'application/json'});

    let data = {"username": username, "password": password};
    let UIResponse = {'Success': false, 'message': ''};
    return this.httpClient.post<any>(url, data, {headers: headers})
      .pipe(tap(result => {
        if(result.status == 200){
          this.doLoginUser(result.userName, result.userCode, result.companyName, result.companyWebsite, result.tokens);
          result.message = Constants.LOGGED_IN_SUCCESS_MESSAGE;
        }
      }))
  }

  public changePassword(username: string, password: string): Observable<any>{
    console.log("Changing Password");
    let url = this.API_URL + 'change-password';
    console.log(url);
    let headers = new HttpHeaders({'Content-Type': 'application/json'});

    let data = {"username": username, "password": password};

    return this.httpClient.post<any>(url, data, {headers: headers})
      .pipe(tap(result => {
        console.log(result);
        if(result.status == 200){
          result.message = Constants.LOGGED_IN_SUCCESS_MESSAGE;
        }
      }))
  }

  public getDocuments(): Observable<any>{
    let userCode = this.getUserCode();
    let url = this.API_URL + `document-list`;

    let headers = new HttpHeaders({'Content-Type': 'application/json'});
    let params = new HttpParams();

    let data = {'userCode': userCode};

    params.append('userCode', userCode);
    return this.httpClient.get(url, {headers: headers, params: data})

  }

  private getUserCode(): string{
    if(!this.loggedInUser || this.loggedInUser === ''){
      this.loggedInUser = localStorage.getItem(Constants.USER_CODE);
    }
    return this.loggedInUser;
  }

  public getUserCompany(): string{
    if(!this.loggInCompany || this.loggInCompany === ''){
      this.loggInCompany = localStorage.getItem(Constants.COMPANY_NAME)
    }
    return this.loggInCompany;
  }

  public getUserCompanyWebsite(): string{
    if(!this.loggedInCompanyWebsite || this.loggedInCompanyWebsite === ''){
      this.loggedInCompanyWebsite = localStorage.getItem(Constants.COMPANY_WEBSITE)
    }
    return this.loggedInCompanyWebsite;
  }

  public logout(){
    this.doLogOutUser();
  }

  private doLogOutUser(){
    this.loggedInUser = null;
    console.log("Removing Tokens");
    this.removeTokens();
  }

  private removeTokens(){
    localStorage.removeItem(Constants.JWT_TOKEN);
    localStorage.removeItem(Constants.REFRESH_TOKEN);

    localStorage.removeItem(Constants.USER);
    localStorage.removeItem(Constants.USER_CODE);

    localStorage.removeItem(Constants.COMPANY_NAME);
    localStorage.removeItem(Constants.COMPANY_WEBSITE);
  }

  private getRefreshToken(){
    return localStorage.getItem(Constants.REFRESH_TOKEN);
  }
  private getjwtToken(){
    return localStorage.getItem(Constants.JWT_TOKEN);
  }

  private doLoginUser(username: string, userCode: string, companyName: string, companyWebsite: string, tokens: Token){
    this.loggedInUser = userCode;
    this.loggInCompany = companyName;
    this.storeTokens(tokens, username, userCode, companyName, companyWebsite);
  }

  private storeTokens(tokens: Token, username: string, userCode: string, companyName: string, companyWebsite: string){
    localStorage.setItem(Constants.JWT_TOKEN, tokens.jwt);
    localStorage.setItem(Constants.REFRESH_TOKEN, tokens.refreshToken);
    localStorage.setItem(Constants.USER, username);
    localStorage.setItem(Constants.USER_CODE, userCode);

    localStorage.setItem(Constants.COMPANY_NAME, companyName);
    localStorage.setItem(Constants.COMPANY_WEBSITE, companyWebsite);
  }

  private storeJwtToken(jwt: string){
    localStorage.setItem(Constants.JWT_TOKEN, jwt);
  }

  public isLoggedIn(){
    return !!this.getjwtToken();
  }
}
